"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowPersonaOptions = exports.workflowEventStatusOptions = exports.tableColumns = exports.NodeConfigurations = exports.NodeCategoryLabels = exports.nodeTypes = exports.DefaultNodeIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var models_1 = require("@doshexchnage/models");
var objectStatuses_1 = require("../../../../../constants/objectStatuses");
var app_payment_objective_node_1 = __importDefault(require("./nodes/objective_nodes/app_payment_objective_node"));
var badge_reward_node_1 = require("./nodes/reward_nodes/badge_reward_node");
var basket_value_objective_node_1 = __importDefault(require("./nodes/objective_nodes/basket_value_objective_node"));
var cashback_reward_node_1 = __importDefault(require("./nodes/reward_nodes/cashback_reward_node"));
var daterange_condition_node_1 = __importDefault(require("./nodes/condition_nodes/daterange_condition_node"));
var earn_objective_node_1 = __importDefault(require("./nodes/objective_nodes/earn_objective_node"));
var event_type_objective_node_1 = __importDefault(require("./nodes/objective_nodes/event_type_objective_node"));
var expression_condition_node_1 = __importDefault(require("./nodes/condition_nodes/expression_condition_node"));
var first_occurance_condition_node_1 = __importDefault(require("./nodes/condition_nodes/first_occurance_condition_node"));
var product_purchased_objective_node_1 = __importDefault(require("./nodes/objective_nodes/product_purchased_objective_node"));
var gift_objective_node_1 = __importDefault(require("./nodes/objective_nodes/gift_objective_node"));
var leaderboard_objective_node_1 = __importDefault(require("./nodes/objective_nodes/leaderboard_objective_node"));
var login_objective_node_1 = __importDefault(require("./nodes/objective_nodes/login_objective_node"));
var mdi_rhombus_split_1 = require("../../../../../components/icons/mdi:rhombus-split");
var order_value_objective_node_1 = __importDefault(require("./nodes/objective_nodes/order_value_objective_node"));
var order_volume_objective_node_1 = __importDefault(require("./nodes/objective_nodes/order_volume_objective_node"));
var payment_method_condition_node_1 = __importDefault(require("./nodes/condition_nodes/payment_method_condition_node"));
var qr_code_objective_node_1 = require("./nodes/objective_nodes/qr_code_objective_node");
var recurring_condition_node_1 = __importDefault(require("./nodes/condition_nodes/recurring_condition_node"));
var referral_objective_node_1 = __importDefault(require("./nodes/objective_nodes/referral_objective_node"));
var statistic_reward_node_1 = __importDefault(require("./nodes/reward_nodes/statistic_reward_node"));
var subscription_objective_node_1 = __importDefault(require("./nodes/objective_nodes/subscription_objective_node"));
var time_condition_node_1 = __importDefault(require("./nodes/condition_nodes/time_condition_node"));
var unique_condition_node_1 = __importDefault(require("./nodes/condition_nodes/unique_condition_node"));
var voucher_objective_node_1 = __importDefault(require("./nodes/objective_nodes/voucher_objective_node"));
exports.DefaultNodeIcon = (0, jsx_runtime_1.jsx)(mdi_rhombus_split_1.MdiRhombusSplit, {});
var objectiveNodeTypes = {
    app_payment_objective: app_payment_objective_node_1.default,
    number_of_logins_objective: login_objective_node_1.default,
    basket_value_objective: basket_value_objective_node_1.default,
    order_value_objective: order_value_objective_node_1.default,
    order_volume_objective: order_volume_objective_node_1.default,
    gift_objective: gift_objective_node_1.default,
    product_purchased_objective: product_purchased_objective_node_1.default,
    leaderboard_objective: leaderboard_objective_node_1.default,
    qr_code_objective: qr_code_objective_node_1.QrCodeObjectiveNode,
    referral_objective: referral_objective_node_1.default,
    subscription_objective: subscription_objective_node_1.default,
    voucher_objective: voucher_objective_node_1.default,
    earn_objective: earn_objective_node_1.default,
    event_type_objective: event_type_objective_node_1.default,
};
var conditionNodeTypes = {
    // filter: OrderProductCategoryFilterNode,
    // and_condition: AndConditionNode,
    recurring_condition: recurring_condition_node_1.default,
    unique_condition: unique_condition_node_1.default,
    date_range_condition: daterange_condition_node_1.default,
    time_condition: time_condition_node_1.default,
    first_occurance_condition: first_occurance_condition_node_1.default,
    payment_method_condition: payment_method_condition_node_1.default,
    expression_condition: expression_condition_node_1.default,
};
var rewardNodeTypes = {
    badge_reward: badge_reward_node_1.BadgeRewardNode,
    cashback_reward: cashback_reward_node_1.default,
    statistic_reward: statistic_reward_node_1.default,
};
exports.nodeTypes = __assign(__assign(__assign({}, objectiveNodeTypes), conditionNodeTypes), rewardNodeTypes);
exports.NodeCategoryLabels = {
    template: "Templates",
    objective: "Objectives",
    condition: "Conditions",
    reward: "Rewards",
};
exports.NodeConfigurations = {
    template: [
        {
            type: "template",
            data: {
                name: "Template",
                node_type: "template",
                icon: "T",
                config: {},
            },
        },
    ],
    objective: [
        {
            type: "number_of_logins_objective",
            data: {
                name: "Logins",
                node_type: "objective",
                config: {
                    event_type: "numberOfLogins",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scope: null,
                },
                schema: {
                    ref: new models_1.Schema({
                        client_id: {
                            type: String,
                        },
                        user_id: {
                            type: String,
                        },
                    }),
                },
                disallow: Object.keys(conditionNodeTypes).filter(function (type) { return type !== "recurring_condition"; }),
            },
        },
        {
            type: "basket_value_objective",
            data: {
                name: "Basket Value",
                node_type: "objective",
                config: {
                    event_type: "basketValue",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 0,
                    },
                    scope: {
                        type: "basket",
                        value: "",
                    },
                },
                schema: {
                    ref: models_1.Order,
                },
                disallow: ["condition"],
            },
        },
        {
            type: "order_value_objective",
            data: {
                name: "Order Value",
                node_type: "objective",
                config: {
                    event_type: "orderValue",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 0,
                    },
                    scope: {
                        type: "basket",
                        value: "",
                    },
                },
                schema: {
                    ref: models_1.Order,
                },
                disallow: ["condition"],
            },
        },
        {
            type: "order_volume_objective",
            data: {
                name: "Order Volume",
                node_type: "objective",
                config: {
                    event_type: "orderVolume",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 0.0,
                    },
                    scope: {
                        type: "basket",
                        value: "",
                        match_all: false,
                    },
                },
                schema: {
                    ref: models_1.Order,
                },
            },
        },
        {
            type: "gift_objective",
            data: {
                name: "Gifts",
                node_type: "objective",
                config: {
                    event_type: "numberOfGifts",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scope: null,
                },
                disallow: ["condition"],
                allow: ["payment_method_condition"],
            },
        },
        {
            type: "leaderboard_objective",
            data: {
                name: "Leaderboard",
                node_type: "objective",
                config: {
                    event_type: "leaderboard",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_target: "totalOrderValue",
                        trigger_quantity: 1,
                    },
                    scope: null,
                },
                disallow: ["condition"],
            },
        },
        {
            type: "referral_objective",
            data: {
                name: "Referrals",
                node_type: "objective",
                config: {
                    event_type: "numberOfReferrals",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scope: null,
                },
                disallow: ["condition"],
            },
        },
        {
            type: "voucher_objective",
            data: {
                name: "Vouchers",
                node_type: "objective",
                config: {
                    event_type: "numberOfVouchers",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scope: null,
                },
                disallow: ["condition"],
            },
        },
        {
            type: "earn_objective",
            data: {
                name: "Earn Currency",
                node_type: "objective",
                config: {
                    event_type: "earn",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                        trigger_type: "currency",
                        trigger_target: "",
                    },
                    scope: null,
                },
                disallow: ["condition"],
            },
        },
        {
            type: "app_payment_objective",
            data: {
                name: "App Payment",
                node_type: "objective",
                config: {
                    event_type: "appPayment",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scopes: [],
                },
                disallow: ["condition"],
            },
        },
        {
            type: "qr_code_objective",
            data: {
                name: "Scan to Earn",
                node_type: "objective",
                config: {
                    event_type: "qrCode",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scopes: [],
                },
                disallow: ["condition"],
            },
        },
        {
            type: "product_purchased_objective",
            data: {
                name: "Product Purchased",
                node_type: "objective",
                config: {
                    event_type: "productPurchased",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scope: {
                        type: "products",
                        value: "",
                        match_all: false,
                    },
                },
                schema: {
                    ref: models_1.Order,
                },
            },
        },
        {
            type: "subscription_objective",
            data: {
                name: "Subscription",
                node_type: "objective",
                config: {
                    event_type: "subscription",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                    },
                    scopes: [],
                },
                disallow: ["condition"],
            },
        },
        {
            type: "event_type_objective",
            data: {
                name: "Custom Event",
                node_type: "objective",
                config: {
                    event_type: "",
                    objective_id: null,
                    title: "",
                    trigger: {
                        trigger_quantity: 1,
                        trigger_target: "",
                    },
                },
                disallow: [],
            },
        },
    ],
    condition: [
        {
            type: "recurring_condition",
            data: {
                name: "Recurring",
                node_type: "condition",
                config: {
                    type: "recurring",
                    frequency: "daily",
                    interval: 1,
                    day: "monday", // cron format instead maybe?
                    count: 1,
                },
                disallow: ["objective", "recurring_condition"],
            },
        },
        {
            type: "unique_condition",
            data: {
                name: "Unique",
                node_type: "condition",
                config: {
                    type: "unique",
                    field: "",
                },
                disallow: ["objective", "unique_condition"],
            },
        },
        {
            type: "date_range_condition",
            data: {
                name: "Date Range",
                node_type: "condition",
                config: {
                    type: "date_range",
                    range_type: "duration", // duration or between
                    days: "", // duration in days
                    start_date: "",
                    end_date: "",
                },
                disallow: ["objective", "date_range_condition"],
            },
        },
        {
            type: "time_condition",
            data: {
                name: "Time",
                node_type: "condition",
                config: {
                    type: "time",
                    range_type: "after",
                    time: "12:00",
                },
                disallow: ["objective", "time_condition"],
            },
        },
        {
            type: "first_occurance_condition",
            data: {
                name: "First Occurance",
                node_type: "condition",
                config: {
                    type: "first_occurance",
                    frequency: "day",
                },
                disallow: ["objective", "first_occurance_condition"],
            },
        },
        {
            type: "payment_method_condition",
            data: {
                name: "Payment Method",
                node_type: "condition",
                config: {
                    type: "payment_method",
                    value: "",
                },
                disallow: ["objective", "payment_method_condition"],
            },
        },
        {
            type: "expression_condition",
            data: {
                name: "Expression",
                node_type: "condition",
                config: {
                    type: "expression",
                    expression: "",
                },
                disallow: ["objective", "expression_condition"],
            },
        },
    ],
    reward: [
        {
            type: "badge_reward",
            data: {
                name: "Badge",
                node_type: "reward",
                config: {
                    type: "badge", // Fixed: changed from "badges" to match backend API
                    value: "",
                    currency_type: null,
                    currency: null,
                },
                disallow: ["objective", "condition"],
            },
        },
        {
            type: "statistic_reward",
            data: {
                name: "XP",
                node_type: "reward",
                config: {
                    type: "xp", // refactor to use stat_change reward type
                    value: "",
                    currency_type: null,
                    currency: null,
                },
                disallow: ["objective", "condition"],
            },
        },
        {
            type: "statistic_reward",
            data: {
                name: "Levels",
                node_type: "reward",
                config: {
                    type: "level", // refactor to use stat_change reward type
                    value: "",
                    currency_type: null,
                    currency: null,
                },
                disallow: ["objective", "condition"],
            },
        },
        {
            type: "cashback_reward",
            data: {
                name: "Cashback",
                node_type: "reward",
                config: {
                    type: "cashback",
                    value: "",
                    currency_type: null,
                    currency: null,
                    cashback_type: "percentage", // or fixed
                },
            },
        },
    ],
};
exports.tableColumns = [
    {
        displayKey: "name",
        label: "Name",
    },
    {
        displayKey: "nodes",
        label: "Nodes",
        formatter: function (_) { var _a; return (_a = _ === null || _ === void 0 ? void 0 : _.nodes) === null || _a === void 0 ? void 0 : _a.length; },
    },
    {
        displayKey: "updatedAt",
        label: "Last Saved",
    },
];
exports.workflowEventStatusOptions = {
    orders: objectStatuses_1.orderStatuses.map(function (status) { return ({
        label: status,
        value: status,
    }); }),
    parcels: objectStatuses_1.parcelStatuses.map(function (status) { return ({
        label: status,
        value: status,
    }); }),
};
exports.workflowPersonaOptions = [
    {
        label: "Customer",
        value: "customer",
    },
    {
        label: "Branch-Manager",
        value: "branch-manager",
    },
    {
        label: "Admin",
        value: "admin",
    },
    {
        label: "Custom",
        value: "custom",
    },
];
